import React from 'react'
import { PricingPlan } from '../types'
import { PricingPlanElement } from '../pricingPlan'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import './removePricingPlanModal.scss'

interface RemovePricingPlanModalProps {
    pricingPlan: PricingPlan
    onRemove: () => void
    onDismiss: () => void
}

export const RemovePricingPlanModal = ({ pricingPlan, onRemove, onDismiss }: RemovePricingPlanModalProps) => (
    <Modal className="remove-pricing-plan-modal" title="Remove pricing plan" onDismiss={onDismiss}>
        <ModalBody>
            <p>Are you sure you want to remove this pricing plan?</p>
            <PricingPlanElement pricingPlan={pricingPlan} />
        </ModalBody>
        <ModalFooter>
            <CancelButton onClick={onDismiss} size="large" />
            <PressAndHoldButton text="Remove" destructive onComplete={onRemove} />
        </ModalFooter>
    </Modal>
)
